/**
 * PreviewAuthority — Authority badges/list with chips or list variant
 */

interface AuthorityItem {
  icon?: string;
  text: string;
}

interface PreviewAuthorityProps {
  data: {
    title?: string;
    variant?: 'chips' | 'list';
    items?: AuthorityItem[];
  };
}

export function PreviewAuthority({ data }: PreviewAuthorityProps) {
  const variant = data.variant || "chips";
  return (
    <section className="preview-authority">
      <div className="preview-container">
        <div
          className="preview-section-header"
          style={{ marginBottom: 16 }}
        >
          <h2>{data.title}</h2>
        </div>
        {variant === "list" ? (
          <ul className="preview-authority__list">
            {(data.items || []).map((it, i) => (
              <li key={i} className="preview-authority__item">
                <span className="preview-authority__icon">
                  {it.icon || "\u2705"}
                </span>
                <span>{it.text}</span>
              </li>
            ))}
          </ul>
        ) : (
          <div className="preview-authority__chips">
            {(data.items || []).map((it, i) => (
              <div key={i} className="preview-authority__chip">
                <span className="preview-authority__icon">
                  {it.icon || "\u2705"}
                </span>
                <span>{it.text}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
